(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-beneficios-section]').forEach((section) => {
      if (section.dataset.enhanced) return;
      const content = section.querySelector('[data-beneficios-content]');
      const headings = [...content.children].filter((node) => node.tagName === 'H3');
      if (!headings.length) return;
      section.dataset.enhanced = 'true';
      const index = section.querySelector('.clp-beneficios__index');
      const list = index.querySelector('ul');
      const groups = headings.map((heading, position) => {
        const previous = heading.previousElementSibling;
        const previousImage = previous?.querySelector('img');
        const imageOnly = previousImage && !previous.textContent.trim();
        return {
          heading,
          start: imageOnly ? previous : heading,
          image: heading.querySelector('img') || (imageOnly ? previousImage : null),
          id: `${section.id || 'beneficios'}-benefit-${position + 1}`
        };
      });
      groups.forEach((group, position) => {
        const wrapper = document.createElement('article');
        wrapper.className = 'clp-beneficios__benefit';
        wrapper.id = group.id;
        const text = document.createElement('div');
        text.className = 'clp-beneficios__prose';
        let current = group.start;
        const end = groups[position + 1]?.start;
        content.insertBefore(wrapper, current);
        while (current && current !== end) {
          const next = current.nextSibling;
          text.append(current);
          current = next;
        }
        if (group.image) {
          const media = document.createElement('div');
          media.className = 'clp-beneficios__media';
          group.image.loading = 'lazy';
          media.append(group.image);
          wrapper.append(media);
        }
        wrapper.append(text);
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${group.id}`;
        link.textContent = group.heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      index.hidden = false;
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
